export default defineNuxtPlugin(() => {
    if (process.client) {
      console.warn = () => {};
    }
  });
  